import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import TotalBox from './TotalBox'
import StatusCountBar from './StatusCountBar'
import H1 from '../typography/headers/H1'
import H2 from '../typography/headers/H2'
import H3 from '../typography/headers/H3'
import P1 from '../typography/paragraphs/P1'
import Caption1 from '../typography/captions/Caption1'
import { formatNumberForThreeDigits } from '../../utils/numbers'

const TotalTotalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const OtherTotalsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 620px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 42px;
`

const OtherTotalContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const StyledCaption1 = styled(Caption1)`
  position: absolute;
  bottom: -27px;
  white-space: nowrap;
  pointer-events: none;
`

const DraftTotalsContainer = styled(OtherTotalContainer)`
  width: 262px;
  padding-right: 17px;
  border-radius: 5px;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.05);
  flex-direction: row;
`

const SubDraftStatusTotalLabel = styled(P1)`
  color: #ffffff;
  display: inline-block;
`

const SubDraftStatusTotalAsterisk = styled(H3)`
  display: inline-block;
  color: #ffffff;
  margin-left: 3px;
`

const TotalsSection = ({ totalCounts }) => (
  <div style={{ display: 'flex', width: '100%' }}>
    <div style={{ paddingRight: '110px' }}>
      <H2
        style={{
          paddingBottom: '10px',
          color: '#444444'
        }}
      >
        Total Quests
      </H2>
      <TotalTotalContainer>
        <H1>{formatNumberForThreeDigits(totalCounts.totalTotal)}</H1>
      </TotalTotalContainer>
    </div>
    <div>
      <OtherTotalsContainer>
        <DraftTotalsContainer>
          <TotalBox
            background="#999999"
            tooltipId="draft-total-tootlip"
            tooltipText={
              <span>
                Number of quests currently in Draft. This includes those
                considered to be in Experience/Subject<sup>*</sup> and Copy Edit
                <sup>*</sup>.
              </span>
            }
          >
            <H2 style={{ color: 'white' }}>
              {formatNumberForThreeDigits(totalCounts.draftTotal)}
            </H2>
            <StyledCaption1>Draft</StyledCaption1>
          </TotalBox>

          <TotalBox
            background="#999999"
            small
            tooltipId="experience-subject-total-tootlip"
            tooltipText={
              <span>
                *&nbsp;Number of quests currently assigned to a quest manager
                with Experience and/or Subject not checked as complete.
              </span>
            }
          >
            <SubDraftStatusTotalLabel>
              {formatNumberForThreeDigits(totalCounts.internalReviewTotal)}
              <SubDraftStatusTotalAsterisk>
                <sup>*</sup>
              </SubDraftStatusTotalAsterisk>
            </SubDraftStatusTotalLabel>
            <StyledCaption1 style={{ bottom: '-38px' }}>
              Experience/Subject&nbsp;<sup>*</sup>
            </StyledCaption1>
          </TotalBox>

          <TotalBox
            background="#999999"
            small
            tooltipId="copy-edit-total-tootlip"
            tooltipText={
              <span>
                *&nbsp;Number of quests that have Experience and Subject checked
                as complete with only Copy remaining.
              </span>
            }
          >
            <SubDraftStatusTotalLabel>
              {formatNumberForThreeDigits(totalCounts.copyEditTotal)}
              <SubDraftStatusTotalAsterisk>
                <sup>*</sup>
              </SubDraftStatusTotalAsterisk>
            </SubDraftStatusTotalLabel>
            <StyledCaption1 style={{ bottom: '-38px' }}>
              Copy Edit&nbsp;<sup>*</sup>
            </StyledCaption1>
          </TotalBox>
        </DraftTotalsContainer>

        <OtherTotalContainer>
          <TotalBox
            style={{ marginLeft: '30px' }}
            background="repeating-linear-gradient(45deg, #999999, #999999 5px, black 6px, black 6px)"
          >
            <H2 style={{ color: 'white' }}>
              {formatNumberForThreeDigits(totalCounts.rejectedTotal)}
            </H2>
            <StyledCaption1>Review Returned</StyledCaption1>
          </TotalBox>
        </OtherTotalContainer>

        <OtherTotalContainer>
          <TotalBox style={{ marginLeft: '30px' }} background="#000000">
            <H2 style={{ color: 'white' }}>
              {formatNumberForThreeDigits(totalCounts.qualityReviewTotal)}
            </H2>
            <StyledCaption1>Publication Review</StyledCaption1>
          </TotalBox>
        </OtherTotalContainer>

        <OtherTotalContainer>
          <TotalBox style={{ marginLeft: '30px' }} background="#00bc80">
            <H2 style={{ color: 'white' }}>
              {formatNumberForThreeDigits(totalCounts.publishedTotal)}
            </H2>
            <StyledCaption1>Published</StyledCaption1>
          </TotalBox>
        </OtherTotalContainer>
      </OtherTotalsContainer>

      <StatusCountBar
        draftCount={totalCounts.draftTotal}
        rejectedCount={totalCounts.rejectedTotal}
        qualityReviewCount={totalCounts.qualityReviewTotal}
        publishedCount={totalCounts.publishedTotal}
        totalCount={totalCounts.totalTotal}
        width={621}
        height={10}
      />
    </div>
  </div>
)

TotalsSection.propTypes = {
  totalCounts: PropTypes.object.isRequired
}

export default TotalsSection



// WEBPACK FOOTER //
// ./src/components/productionstatus/TotalsSection.js